import { Component, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Chip } from 'primeng/chip';
import { CommonModule } from '@angular/common';
import Icons from '../../shared-components/icon/icons';

@Component({
  selector: 'app-chip',
  imports: [Chip, CommonModule],
  templateUrl: './chips.component.html',
  styleUrl: './chips.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class AppChip {
  @Input() public color = ''; // primary, secondary
  @Input() public label = '';
  @Input() public disabled = false;
  @Input() public withIcon = false;
  @Input() public iconName = '';
  @Input() public iconType = '';
  @Input() public withCloseIcon = false;

  public get iconClass(): string {
    return this.iconType
      ? `ph-${this.iconType} ph-${this.iconName} ph-icon`
      : `ph ph-${this.iconName} ph-icon`;
  }

  private readonly icons = Icons;
}
